import ContainerType from ".";

export const containerType = [
  {
    path: "/containerType",
    element: <ContainerType />,
  },
];
